import StaffRepository from './staffRepository';
import DepartmentsRepository from './departmentsRepository';
import PermissionsRepository from './PermissionsRepository';
import RolesRepository from './RolesRepository';
import SupplierRepository from './supplierRepository';
import supplierManufactureRepository from './supplierManufactureRepository';
import supplierRawMaterialRepository from './supplierRawMaterialRepository';
import tradingRepository from './tradingRepository';
import NotificationsRepository from "@/repository/NotificationsRepository";

const repositories = {
  staff : StaffRepository,
  departments : DepartmentsRepository,
  permissions : PermissionsRepository,
  roles : RolesRepository,
  supplier : SupplierRepository,
  supplierManufacture : supplierManufactureRepository,
  supplierRawMaterial: supplierRawMaterialRepository,
  trading: tradingRepository,
  notification: NotificationsRepository,
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
